export const ArrowIcon = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="10"
      height="6"
      viewBox="0 0 10 6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.540639 4.46685L4.49886 0.539508C4.63174 0.407703 4.81194 0.333659 4.99984 0.333659C5.18773 0.333659 5.36793 0.407703 5.50081 0.539508L9.45904 4.46685C9.5581 4.56518 9.62557 4.69044 9.6529 4.8268C9.68023 4.96316 9.66619 5.1045 9.61257 5.23296C9.55895 5.36141 9.46815 5.4712 9.35165 5.54846C9.23515 5.62571 9.09818 5.66696 8.95806 5.66699L1.04162 5.66699C0.90149 5.66696 0.76452 5.62571 0.64802 5.54846C0.53152 5.4712 0.440721 5.36141 0.387101 5.23296C0.333481 5.10451 0.319448 4.96317 0.346778 4.8268C0.374106 4.69044 0.44157 4.56518 0.540639 4.46685Z" />
    </svg>
  )
}
